import request from '@/router/axios'

const API = '/api/produce/kanban/transport-plan-progress'

function unwrap(res) {
  const body = res && res.data
  if (body && Object.prototype.hasOwnProperty.call(body, 'data')) return body.data
  return body
}

function n(v) {
  const x = Number(v)
  return Number.isFinite(x) ? x : 0
}

function nullableNumber(v) {
  if (v == null || v === '') return null
  const x = Number(v)
  return Number.isFinite(x) ? x : null
}

function resolveWarningLevel(item) {
  if (['red', 'yellow', 'green', 'none'].indexOf(item.warningLevel) >= 0) {
    return item.warningLevel
  }
  const rate = nullableNumber(item.completionRatePercent)
  if (rate == null) return 'none'
  if (rate < 60) return 'red'
  if (rate <= 80) return 'yellow'
  return 'green'
}

function warningLabel(level) {
  if (level === 'red') return '红色预警'
  if (level === 'yellow') return '黄色预警'
  if (level === 'green') return '绿色标识'
  return '无计划量'
}

function pickTotalCount(summary, items) {
  if (summary.totalCount != null) return summary.totalCount
  if (summary.planCount != null) return summary.planCount
  return items.length
}

function pickWeightedRate(summary, fallbackRate) {
  if (summary.weightedRatePercent != null) return summary.weightedRatePercent
  if (summary.completionRatePercent != null) return summary.completionRatePercent
  return fallbackRate
}

function normalizeItem(item = {}) {
  const row = {
    id: item.id,
    planNo: item.planNo || '',
    planName: item.planName || '',
    businessType: item.businessType,
    businessTypeLabel: item.businessTypeLabel || '',
    custName: item.custName || '',
    cargoName: item.cargoName || '',
    intervalStartStr: item.intervalStartStr || '',
    intervalEndStr: item.intervalEndStr || '',
    planTotalWeight: n(item.planTotalWeight),
    planExecuteWeight: n(item.planExecuteWeight),
    completionRatePercent: nullableNumber(item.completionRatePercent),
    warningLevel: item.warningLevel,
    warningLabel: item.warningLabel
  }
  row.warningLevel = resolveWarningLevel(row)
  row.warningLabel = row.warningLabel || warningLabel(row.warningLevel)
  return row
}

function buildSummary(summary = {}, items = []) {
  const fallback = items.reduce(
    (acc, item) => {
      if (item.warningLevel === 'red') acc.redCount += 1
      if (item.warningLevel === 'yellow') acc.yellowCount += 1
      if (item.warningLevel === 'green') acc.greenCount += 1
      acc.planTotalWeight += item.planTotalWeight
      acc.planExecuteWeight += item.planExecuteWeight
      return acc
    },
    { redCount: 0, yellowCount: 0, greenCount: 0, planTotalWeight: 0, planExecuteWeight: 0 }
  )
  const fallbackRate = fallback.planTotalWeight > 0
    ? Number(((fallback.planExecuteWeight / fallback.planTotalWeight) * 100).toFixed(2))
    : null
  return {
    totalCount: n(pickTotalCount(summary, items)),
    redCount: n(summary.redCount != null ? summary.redCount : fallback.redCount),
    yellowCount: n(summary.yellowCount != null ? summary.yellowCount : fallback.yellowCount),
    greenCount: n(summary.greenCount != null ? summary.greenCount : fallback.greenCount),
    weightedRatePercent: nullableNumber(pickWeightedRate(summary, fallbackRate))
  }
}

function normalize(data) {
  if (!data || typeof data !== 'object') {
    return { queryDate: '', summary: buildSummary({}, []), items: [] }
  }
  const items = (data.items || []).map(normalizeItem)
  return {
    queryDate: data.queryDate || '',
    summary: buildSummary(data.summary || {}, items),
    items
  }
}

export function fetchTransportPlanProgress(params = {}) {
  return request({
    url: API,
    method: 'post',
    data: {
      queryDate: params.queryDate,
      businessType: params.businessType
    }
  })
    .then(unwrap)
    .then(normalize)
}
